export default __webpack_public_path__ + "static/media/Check_List_Viatura__English.f9fbeabe.pdf";